import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Body from '../content/body';
import Sidebar from '../content/sidebar';
import { ArticleDisclaimer } from '../../fc_executive_board';

const PostDefault = props => {
  const { posts, advertorial } = props;
  const post = get(posts, '[0]', {});
  const tags = Array.from(post.tags, tag => tag.slug);
  const hasFCEB = tags.includes('fast-company-executive-board');

  return (
    <Fragment>
      {hasFCEB && <ArticleDisclaimer />}

      <div className="post post--default">
        <div className="post__main">
          <Body
            {...props}
            post={post}
            isLongPost={true}
            hasNewsletter={true}
            fullPageAdvertorial={advertorial}
            hasFCEB={hasFCEB}
          />
        </div>
        <Sidebar
          {...props}
          post={get(posts, '[0]')}
          fullPageAdvertorial={advertorial}
          isLongPost={true}
        />
      </div>

      {hasFCEB && <div id="pressboard-ad-sponsorship-msg" />}
    </Fragment>
  );
};

PostDefault.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  advertorial: PropTypes.bool.isRequired
};

export default PostDefault;
